import React from "react";
import "./CouponDetails.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import Couponimage from '../../assests/coupon_image.png';
import leftArrow from "../../assests/leftArrow.svg";
import Details from "../../assests/delivery-detail.png";
import Calander from '../../assests/calander.svg';
import dateTime from '../../assests/watch.svg';
import CouponMiniIcon from '../../assests/couponminiicon.png';
import { useNavigate } from "react-router-dom";

const CouponDetails = ({ coupon }) => {
  const navigate = useNavigate();
  
  const arrowClick = () => navigate("/home/coupon/list");

  const utcToIST = (utcDateStr) => {
    const date = new Date(utcDateStr);
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    const istString = date.toLocaleString('en-GB', options); // "18/09/2022, 16:33:38"
    const [datePart, timePart] = istString.split(', ');

    return {
      date: datePart,
      time: timePart,
    };
  };

  const start = coupon?.createdAt ? utcToIST(coupon.createdAt) : null;
  const end = coupon?.expiryDate ? utcToIST(coupon.expiryDate) : null;

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div className="coupon-details-container" style={{ height: "100vh", overflow: "scroll" }}>
        <div className="users-roles-header">
          <button onClick={arrowClick} className="back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h1>{coupon?.name}</h1>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left Main Section */}
          <div className="coupon-main-section" style={{ width: "50vw", boxShadow: "#d4d3e1 4px 4px 10px", marginRight: "2vw" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <img src={CouponMiniIcon} style={{ width: "22px", height: "15px" }} />
              <p style={{ margin: 0, marginLeft: "1vw" }}>Coupons Details</p>
            </div>

            <div className="coupon-left">
              <img src={Couponimage} alt="Coupon" className="coupon-image" />
              <div style={{ display: "flex", width: "100vw", justifyContent: "space-between" }}>
                <div className="coupon-info">
                  <p className="amount-details-text"><strong>Coupon ID:</strong> {coupon?.id}</p>
                  <p className="amount-details-text"><strong>Coupon Name:</strong> {coupon?.name}</p>
                  <p className="amount-details-text"><strong>Coupon Description:</strong> {coupon?.couponDescription}</p>
                  <p className="amount-details-text"><strong>Coupon Type:</strong> {coupon?.type}</p>
                  <p className="amount-details-text"><strong>Coupon Limit:</strong> {coupon?.couponLimit}</p>
                  <p className="amount-details-text"><strong>Coupon Device Usage:</strong> {coupon?.usagePerDevice}</p>
                </div>
                <div>
                  <span className="published-status">Published</span>
                </div>
              </div>
            </div>

            {/* Date Time Section */}
            <div className="coupon-date-time" style={{ marginTop: "5vw" }}>
              <div className="date-block">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  {/* Start Date */}
                  <div>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <img src={Calander} style={{ marginRight: "10px" }} />
                      <p className="amount-details-text"><strong>Start Date:</strong> {start?.date}</p>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <img src={dateTime} style={{ marginRight: "10px" }} />
                      <p className="amount-details-text"><strong>Time:</strong> {start?.time}</p>
                    </div>
                  </div>

                  {/* End Date */}
                  <div>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <img src={Calander} style={{ marginRight: "10px" }} />
                      <p className="amount-details-text"><strong>End Date:</strong> {end?.date}</p>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <img src={dateTime} style={{ marginRight: "10px" }} />
                      <p className="amount-details-text"><strong>Time:</strong> {end?.time}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Amount Section */}
          <div className="coupon-amount-section" style={{ width: "20vw", boxShadow: "#d4d3e1 4px 4px 10px" }}>
            <h3 className="amount-details-text">Amount Details</h3>
            <hr />
            <p className="amount-details-text"><strong>Max Cash Back:</strong> {coupon?.maxCashback}</p>
            <p className="amount-details-text"><strong>Min Cash Back:</strong> {coupon?.minCashBack}</p>
            <p className="amount-details-text"><strong>Amount Type Details:</strong> {coupon?.amountType}</p>
{/*             <p className="amount-details-text"><strong>Recharge Cashback:</strong> {coupon?.rechargeCashback}</p>
            <p className="amount-details-text"><strong>Payment Gateway:</strong> {coupon?.paymentGateway}</p> */}
          </div>
        </div>

        {/* Other Details Section */}
        <div className="coupon-other-section">
          <div style={{ display: "flex", justifyItems: "center" }}>
            <img src={Details} style={{ width: "20px", height: "20px" }} />
            <h3 className="amount-details-text">Other Details</h3>
          </div>
          <hr />
          <p className="amount-details-text"><strong>Applied to VM:</strong> {coupon?.appliedVm || "—"}</p>
          <p className="amount-details-text"><strong>Free Gift Details:</strong> {coupon?.freeGift || "—"}</p>
        </div>

        {/* T&C Section */}
        <div className="coupon-tnc">
          <p style={{ fontSize: "12px" }}>
            <strong>*T&C Apply:</strong> This coupon can be used 1 time by a user in 7 days.
            Offer valid till 15th March 2025. The coupon will be applicable on all products.
            This offer cannot be combined with other offers. Other standard terms and conditions apply.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponDetails;
